import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },


  
  // 组件块
  //头部
  {
    path: '/Herder',
    name: 'Herder',
    component: () => import('../views/qianduan/HeaderView.vue')
  },
  {
    path: '/Footer',
    name: 'Footer',
    component: () => import('../views/qianduan/FooterView.vue')
  },
  {
    path: '/Img',
    name: 'Img',
    component: () => import('../views/qianduan/ImgView.vue')
  },

  //菜单
  //联系我们
  {
    path: '/A151',
    name: 'A151',
    component: () => import('../views/About/A151View.vue')
  },
  {
    path: '/A111',
    name: 'A111',
    component: () => import('../views/About/A111View.vue')
  },
  {
    path: '/A112',
    name: 'A112',
    component: () => import('../views/About/A112View.vue')
  },
  {
    path: '/A113',
    name: 'A113',
    component: () => import('../views/About/A113View.vue')
  },
  {
    path: '/A121',
    name: 'A121',
    component: () => import('../views/About/A121View.vue')
  },


]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
